import { ref, remove, get, update } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import GetQuotationDataFirebase from "../../Quotation/GetQuotationDataFirebase";

const DeleteAssignerUserQuotationDataInFirebase = async (state, dispatch, uniqueID, userID, ownerUid) => {
    if (!ownerUid) return null;

    

    try {

        // Reference to the specific invoice in Firebase
        const userRef = ref(database, `invoiceGenerator/users/${ownerUid}/quotation/${uniqueID}`);

        const snapshot = await get(userRef);
        if (!snapshot.exists()) {
            return { success: false, message: "Quotation not found." };
        }

        // Instead of deleting, just mark as deleted
        await update(userRef, { isDeleted: true,
            deletedBy: state?.USERID || "guest" });

        // Fetch updated invoice data after deletion
        await GetQuotationDataFirebase(state, dispatch);

        return { success: true, message: "quotation deleted successfully!" };
    } catch (error) {
        return { success: false, message: error.message || "Failed to delete Proforma invoice." };
    }
};

export default DeleteAssignerUserQuotationDataInFirebase;
